import { isOk } from "@pacote/result"
import useSWR from "swr"
import { z } from "zod"

import { baseExternalFetcher } from "./base-fetchers"

const baseIpFetcher = (url: string) =>
  baseExternalFetcher<{ ip: string }, unknown>({
    url,
    timeout: 10_000,
    successSchemaValidator: z.object({
      ip: z.string().optional(),
    }),
    errorSchemaValidator: z.string(),
    async responseHandler(response) {
      const r = (await response.text()).trim()
      return {
        ip: r.trim(),
      }
    },
  })

// orribile ma se non erro andrà deprecato quindi va bene così
const getIpFetcher = async () => {
  try {
    const firstTry = await baseIpFetcher("https://ipv4.icanhazip.com")
    if (isOk(firstTry)) return firstTry.value

    const secondTry = await baseIpFetcher("https://api.ipify.org")
    if (isOk(secondTry)) return secondTry.value
  } catch {}

  return { ip: "" }
}

/* -------------------------------------------------------------------------------------------------
 * hooks
 * -----------------------------------------------------------------------------------------------*/

const useIpQuery = () =>
  useSWR("get-ip", getIpFetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

export { useIpQuery }
